/* eslint-disable react-native/no-inline-styles */
import * as React from "react";
import { DataTable, Paragraph, useTheme } from "react-native-paper";
import { TYPE_CHOOSE_BENE } from "../../../../../modules/beneficiaries/utils/bene.utils";
import { useMobileMediaQuery } from "@media-query";
import { FlatListItem } from "../select-account-bene.modal";
import ItemAccount from "./item-account";
import ItemBene from "./item-bene";

interface ItemModalProps {
  item: FlatListItem;
  index: number;
  templateType?: string;
  onClick?: Function;
}

interface InfoItemData {
  title: string;
  label: string;
  value: string;
  description: string;
}

const ItemBeneAccountModal = (props: ItemModalProps) => {
  const { item, index, templateType, onClick } = props;
  const { colors, fonts } = useTheme();
  const isMobile = useMobileMediaQuery();

  const RowHeader = () => (
    <DataTable>
      <DataTable.Header style={{ flex: 1, paddingHorizontal: 0, paddingVertical: 0, borderBottomWidth: 1 }}>
        <DataTable.Title style={{ flex: 1 }}>
          <Paragraph style={[fonts.regular, { color: colors.text, fontWeight: "700", paddingVertical: 0 }]}>{item.header?.left}</Paragraph>
        </DataTable.Title>
        {!isMobile ? (
          <DataTable.Title style={{ position: "absolute", right: 0 }}>
            <Paragraph style={[fonts.regular, { color: colors.text, fontWeight: "700" }]}>{item.header?.right}</Paragraph>
          </DataTable.Title>
        ) : null}
      </DataTable.Header>
    </DataTable>
  );

  const renderItem = () => {
    if (item.type === TYPE_CHOOSE_BENE.ACCOUNT) return <ItemAccount item={item} index={index} onClick={onClick} />;
    else return <ItemBene item={item} index={index} onClick={onClick} templateType={templateType} />;
  };

  const renderContent = () => {
    return item?.data ? renderItem() : item?.header ? <RowHeader /> : null;
  };

  return renderContent();
};

export default ItemBeneAccountModal;
